import Button from "@material-ui/core/Button";
import React, { Component } from "react";
import { languages } from "../../constants/languages";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

export default class NewPlayerScoreButton extends Component {
  state = {
    anchorEl: null,
    open: false,
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    return (
      <div>
        <Button
          variant="contained"
          aria-haspopup="true"
          onClick={this.handleMenu}
          color="primary"
        >
          {this.props.label}
        </Button>

        <Menu
          id="menu-appbar"
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
        >
          {(this.props.goals1 || this.props.goals2) && (
            <MenuItem
              value={this.props.goals1 ? "ownGoal1" : "ownGoal2"}
              onClick={(e) => {
                this.handleClose();
                this.props.submitNewGoal(
                  e,
                  this.props.goals1 ? "ownGoal1" : "ownGoal2"
                );
              }}
            >
              {languages.results.ownGoal}
            </MenuItem>
          )}
          {this.props.players.map((player) => (
            <MenuItem
              key={player.id}
              value={player.id}
              onClick={(e) => {
                this.handleClose();
                this.props.submitNewGoal(e, player.id);
              }}
            >
              {player.name + (player.number ? ` (${player.number})` : "")}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}
